/**
 * Returns the current date plus `yearOffset` years as an UTCSstring.
 * @param {number} yearOffset defaults to `1`.
 */
export const dateInTheFuture = (yearOffset = 1) => {
  const originalDate = new Date();
  const year = originalDate.getFullYear();
  const month = originalDate.getMonth();
  const date = originalDate.getDate();

  return new Date(year + yearOffset, month, date).toUTCString();
};
